import { INTRODUCTION_REDUCER_KEY } from "./reducer";
import { TApplicationState } from "../store";
import { TReducerSelector } from "../../ts/general";
import { IIntroductionState } from "../../ts/redux";

const reducerState: TReducerSelector<IIntroductionState> = (state: TApplicationState) => state[INTRODUCTION_REDUCER_KEY];

export const getIntroductionState = (state: TApplicationState) => reducerState(state);